module.exports = __webpack_public_path__ + "img/能源管理系统_03.00323734.png";